/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import * as Q from '../../../../../constants/graphqlQueries';

import './AdminSearch.css';
import CustomDropdown from '../../../../components/Dropdown/CustomDropdown';
import CustomTextField from '../../../../components/Textfield/CustomTextField';
import CustomButtons from '../../../../components/Button/CustomButtons';

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D5D5',
          },
        },
      },
    },
  },
});

const Search = ({ roleEnable, onClearEmployeeData, onSearchClick }) => {
  const [selectedEmployeeFirstName, setSelectedEmployeeFirstName] = useState('');
  const [selectedEmployeeLastName, setSelectedEmployeeLastName] = useState('');
  const [selectedOracleId, setSelectedOracleId] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedSite, setSelectedSite] = useState('');
  const [disabledSearch, setDisabledSearch] = useState(true);

  const [roles, setRoles] = useState({});
  const [sites, setSites] = useState({});

  const { data: dataEmployeesRoles } = useQuery(Q.ADMIN_MANAGMENT_USERS_ROLES);
  const { data: dataSites } = useQuery(Q.APP_ALERT_SITES_GL_QUERY);

  const onClearClick = () => {
    setSelectedEmployeeFirstName('');
    setSelectedEmployeeLastName('');
    setSelectedOracleId('');
    setSelectedRole('');
    setSelectedSite('');
    setDisabledSearch(true);
    onClearEmployeeData();
  };
  const handleSearchEmployees = () => {
    onSearchClick(selectedEmployeeFirstName, selectedEmployeeLastName, selectedOracleId, selectedRole, selectedSite)
  };

  const onChangeEmployeeFirstName = (value) => setSelectedEmployeeFirstName(value);
  const onChangeEmployeeLastName = (value) => setSelectedEmployeeLastName(value);
  const onChangeOracleId = (value) => setSelectedOracleId(value);
  const onChangeRole = (value) => setSelectedRole(value);
  const onChangeSite = (value) => setSelectedSite(value);

  useEffect(() => {
    if (dataSites) {
      const siteProps = {
        options: dataSites.getSites,
        getOptionLabel: (option) => option.DescriptionShort
      }
      setSites(siteProps);
    }
  }, [dataSites]);

  useEffect(() => {
    if (dataEmployeesRoles) {
      const roleProps = {
        options: dataEmployeesRoles.jobRoles,
        getOptionLabel: (option) => option.JobRole
      }
      setRoles(roleProps);
    }
  }, [dataEmployeesRoles]);

  useEffect(() => {
    onClearClick();
  }, [roleEnable]);

  useEffect(() => {
    // State watcher
    if (selectedEmployeeFirstName || selectedEmployeeLastName || selectedOracleId || selectedRole || selectedSite) {
      setDisabledSearch(false);
    }
    else {
      setDisabledSearch(true);
    }
  }, [selectedEmployeeFirstName, selectedEmployeeLastName, selectedOracleId, selectedRole, selectedSite]);

  return (
    <ThemeProvider theme={theme}>
      <Box className='search__wrapper'>
        <Box className='search__title'>
          Search
        </Box>
        <CustomTextField
          title='Employee First Name'
          value={selectedEmployeeFirstName}
          handleChange={onChangeEmployeeFirstName}
          placeholder='Input text'
        />
        <CustomTextField
          title='Employee Last Name'
          value={selectedEmployeeLastName}
          handleChange={onChangeEmployeeLastName}
          placeholder='Input text'
        />
        <CustomTextField
          title='Oracle ID'
          value={selectedOracleId}
          handleChange={onChangeOracleId}
          placeholder='Input text'
        />
        {roleEnable && 
        <CustomDropdown
          title='Role'
          value={selectedRole}
          handleChange={onChangeRole}
          defaultProps={roles}
        />
        }
        <CustomDropdown
          title='Site'
          value={selectedSite}
          handleChange={onChangeSite}
          defaultProps={sites}
        />
        <Box className='search__footer__row'>
          <CustomButtons
            handleClick={onClearClick}
            name='Clear'
          />
          <CustomButtons
            handleClick={handleSearchEmployees}
            disabled={disabledSearch}
            name='Search'
            tooltipFree
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

Search.propTypes = {
  onSearchClick: PropTypes.func.isRequired,
  onClearEmployeeData: PropTypes.func.isRequired,
  roleEnable: PropTypes.bool.isRequired
};

export default Search;
